// extracted by mini-css-extract-plugin
export default {"item":"tramites_item__itW7X","icon":"tramites_icon__hmwik"};